import {isString} from 'lodash';
import React, {HTMLProps, memo} from 'react';
import styled, {css} from 'styled-components';

import type {SvgAsset} from '*.svg';

import autoContactFilledTiny from '../../../../assets/src/icon12/autoContactFilled.svg';
import bellTiny from '../../../../assets/src/icon12/bellFilled.svg';
import busyFilledTiny from '../../../../assets/src/icon12/busyFilled.svg';
import checkmarkBoxTiny from '../../../../assets/src/icon12/checkmarkBox.svg';
import chevronCollapseTiny from '../../../../assets/src/icon12/chevronCollapse.svg';
import chevronDownTiny from '../../../../assets/src/icon12/chevronDown.svg';
import chevronExpandTiny from '../../../../assets/src/icon12/chevronExpand.svg';
import chevronRightTiny from '../../../../assets/src/icon12/chevronRight.svg';
import clockTiny from '../../../../assets/src/icon12/clock.svg';
import closeTiny from '../../../../assets/src/icon12/close.svg';
import copyTiny from '../../../../assets/src/icon12/copy.svg';
import diamondFilledTiny from '../../../../assets/src/icon12/diamondFilled.svg';
import downloadTiny from '../../../../assets/src/icon12/download.svg';
import draftFilledTiny from '../../../../assets/src/icon12/draftFilled.svg';
import editTiny from '../../../../assets/src/icon12/edit.svg';
import exitTiny from '../../../../assets/src/icon12/exit.svg';
import externalLinkTiny from '../../../../assets/src/icon12/externalLink.svg';
import frontLogoTiny from '../../../../assets/src/icon12/frontLogo.svg';
import gearFilledTiny from '../../../../assets/src/icon12/gearFilled.svg';
import lightbulbTiny from '../../../../assets/src/icon12/lightbulb.svg';
import lightningTiny from '../../../../assets/src/icon12/lightning.svg';
import linkTiny from '../../../../assets/src/icon12/link.svg';
import linkedConversationsTiny from '../../../../assets/src/icon12/linkedConversations.svg';
import linkedConversationsFilledTiny from '../../../../assets/src/icon12/linkedConversationsFilled.svg';
import lockFilledTiny from '../../../../assets/src/icon12/lockFilled.svg';
import lockFilledNewTiny from '../../../../assets/src/icon12/lockFilledNew.svg';
import mutedStatusTiny from '../../../../assets/src/icon12/mutedStatus.svg';
import nestedArrowTiny from '../../../../assets/src/icon12/nestedArrow.svg';
import newTiny from '../../../../assets/src/icon12/new.svg';
import oooTiny from '../../../../assets/src/icon12/OOO.svg';
import pinFilledTiny from '../../../../assets/src/icon12/pinFilled.svg';
import plusTiny from '../../../../assets/src/icon12/plus.svg';
import publicApiTiny from '../../../../assets/src/icon12/publicApi.svg';
import questionMarkTiny from '../../../../assets/src/icon12/questionMark.svg';
import replyTiny from '../../../../assets/src/icon12/reply.svg';
import searchTiny from '../../../../assets/src/icon12/search.svg';
import sharedFilledTiny from '../../../../assets/src/icon12/sharedFilled.svg';
import sparklesAiFilledTiny from '../../../../assets/src/icon12/sparklesAIFilled.svg';
import starTiny from '../../../../assets/src/icon12/star.svg';
import subscribeTiny from '../../../../assets/src/icon12/subscribe.svg';
import taskTiny from '../../../../assets/src/icon12/task.svg';
import taskFilledTiny from '../../../../assets/src/icon12/taskFilled.svg';
import unsubscribeTiny from '../../../../assets/src/icon12/unsubscribe.svg';
import warningFilledTiny from '../../../../assets/src/icon12/warningFilled.svg';
import callAnsweredActivity from '../../../../assets/src/icon14/callAnsweredActivity.svg';
import callEndedActivity from '../../../../assets/src/icon14/callEndedActivity.svg';
import callMissedActivity from '../../../../assets/src/icon14/callMissedActivity.svg';
import callOnHoldActivity from '../../../../assets/src/icon14/callOnHoldActivity.svg';
import callQueuedActivity from '../../../../assets/src/icon14/callQueuedActivity.svg';
import callResumedActivity from '../../../../assets/src/icon14/callResumedActivity.svg';
import chatDeflected from '../../../../assets/src/icon14/chatDeflected.svg';
import chatEndedActivity from '../../../../assets/src/icon14/chatEndedActivity.svg';
import checkmarkYesActivity from '../../../../assets/src/icon14/checkmarkYes.svg';
import closedActivity from '../../../../assets/src/icon14/circleLine.svg';
import customFieldsActivity from '../../../../assets/src/icon14/customFieldsActivity.svg';
import gearActivity from '../../../../assets/src/icon14/gearActivity.svg';
import groupActivity from '../../../../assets/src/icon14/groupActivity.svg';
import inboxActivity from '../../../../assets/src/icon14/inboxActivity.svg';
import inboxInboundFilled from '../../../../assets/src/icon14/inboxInboundFilled.svg';
import integrationActivity from '../../../../assets/src/icon14/integrationActivity.svg';
import inviteActivity from '../../../../assets/src/icon14/inviteActivity.svg';
import lightningActivity from '../../../../assets/src/icon14/lightningActivity.svg';
import linkedConversationsFilledMedium from '../../../../assets/src/icon14/linkedConversationsFilled.svg';
import mergeActivity from '../../../../assets/src/icon14/mergeActivity.svg';
import mergeActivityFilled from '../../../../assets/src/icon14/mergeActivityFilled.svg';
import messageActivity from '../../../../assets/src/icon14/message.svg';
import callTransferredActivity from '../../../../assets/src/icon14/moveActivity.svg';
import moveActivity from '../../../../assets/src/icon14/moveActivity.svg';
import questionmarkMaybeActivity from '../../../../assets/src/icon14/questionmarkMaybe.svg';
import removeActivity from '../../../../assets/src/icon14/removeActivity.svg';
import removeIntegrationActivity from '../../../../assets/src/icon14/removeIntegrationActivity.svg';
import snoozeActivity from '../../../../assets/src/icon14/snoozeActivity.svg';
import snoozeActivityFilled from '../../../../assets/src/icon14/snoozeActivityfilled.svg';
import splitActivity from '../../../../assets/src/icon14/splitActivity.svg';
import splitActivityFilled from '../../../../assets/src/icon14/splitActivityFilled.svg';
import squareFilled from '../../../../assets/src/icon14/squareFilled.svg';
import tagActivity from '../../../../assets/src/icon14/tagActivity.svg';
import tagActivityFilled from '../../../../assets/src/icon14/tagActivityFilled.svg';
import task from '../../../../assets/src/icon14/task.svg';
import taskFilled from '../../../../assets/src/icon14/taskFilled.svg';
import topicActivity from '../../../../assets/src/icon14/topicActivity.svg';
import transcriptActivity from '../../../../assets/src/icon14/transcriptActivity.svg';
import trashActivity from '../../../../assets/src/icon14/trashActivity.svg';
import unarchiveActivityFilled from '../../../../assets/src/icon14/unarchiveActivityFilled.svg';
import unassignActivity from '../../../../assets/src/icon14/unassignActivity.svg';
import unassignActivityFilled from '../../../../assets/src/icon14/unassignActivityFilled.svg';
import unlinkedConversationsActivity from '../../../../assets/src/icon14/unlinkedConversationsActivity.svg';
import untagActivity from '../../../../assets/src/icon14/untagActivity.svg';
import untagActivityFilled from '../../../../assets/src/icon14/untagActivityFilled.svg';
import warningActivity from '../../../../assets/src/icon14/warningActivity.svg';
import xNoActivity from '../../../../assets/src/icon14/xNo.svg';
import attachmentSmall from '../../../../assets/src/icon16/attachment.svg';
import auditLogSmall from '../../../../assets/src/icon16/auditLog.svg';
import auditLogFilledSmall from '../../../../assets/src/icon16/auditLogFilled.svg';
import autoContactSmall from '../../../../assets/src/icon16/autoContact.svg';
import autoContactFilledSmall from '../../../../assets/src/icon16/autoContactFilled.svg';
import bellSmall from '../../../../assets/src/icon16/bell.svg';
import bell02Small from '../../../../assets/src/icon16/bell-02.svg';
import bellCrossedSmall from '../../../../assets/src/icon16/bellCrossed.svg';
import briefcaseFilledSmall from '../../../../assets/src/icon16/briefcaseFilled.svg';
import briefcaseOutlineSmall from '../../../../assets/src/icon16/briefcaseOutline.svg';
import buildingFilledSmall from '../../../../assets/src/icon16/buildingFilled.svg';
import calendarSmall from '../../../../assets/src/icon16/calendar.svg';
import calendarFilledSmall from '../../../../assets/src/icon16/calendarFilled.svg';
import callInboundFilledSmall from '../../../../assets/src/icon16/callInboundFilled.svg';
import callMissedSmall from '../../../../assets/src/icon16/callMissed.svg';
import callOutboundFilledSmall from '../../../../assets/src/icon16/callOutboundFilled.svg';
import callOutlinedSmall from '../../../../assets/src/icon16/callOutlined.svg';
import caseStudySmall from '../../../../assets/src/icon16/caseStudy.svg';
import changeStatusSmall from '../../../../assets/src/icon16/changeStatus.svg';
import changeStatusFilledSmall from '../../../../assets/src/icon16/changeStatusFilled.svg';
import channelCallFilledSmall from '../../../../assets/src/icon16/channelCallFilled.svg';
import channelCallOutlineSmall from '../../../../assets/src/icon16/channelCallOutline.svg';
import channelChatSmall from '../../../../assets/src/icon16/channelChat.svg';
import channelChatOutlineSmall from '../../../../assets/src/icon16/channelChatOutline.svg';
import channelEmailSmall from '../../../../assets/src/icon16/channelEmail.svg';
import channelEmailOutlineSmall from '../../../../assets/src/icon16/channelEmailOutlineSmall.svg';
import channelGooglePlaySmall from '../../../../assets/src/icon16/channelGooglePlay.svg';
import channelGooglePlayOutlineSmall from '../../../../assets/src/icon16/channelGooglePlayOutline.svg';
import channelsSmall from '../../../../assets/src/icon16/channels.svg';
import channelsFilledSmall from '../../../../assets/src/icon16/channelsFilled.svg';
import chatbotFilledSmall from '../../../../assets/src/icon16/chatbotFilledSmall.svg';
import chatbotSmall from '../../../../assets/src/icon16/chatbotSmall.svg';
import checkCircleSmall from '../../../../assets/src/icon16/check-circle.svg';
import checkSmallFilled from '../../../../assets/src/icon16/check-fill.svg';
import checkSmallOutline from '../../../../assets/src/icon16/check-outline.svg';
import checkmarkBoxSmall from '../../../../assets/src/icon16/checkmarkBox.svg';
import checkmarkCircleSmall from '../../../../assets/src/icon16/checkmarkCircle.svg';
import checkmarkCircleOutlineSmall from '../../../../assets/src/icon16/checkmarkCircleOutline.svg';
import checkmarkSelectedSmall from '../../../../assets/src/icon16/checkmarkSelected.svg';
import chevronCollapseSmall from '../../../../assets/src/icon16/chevronCollapse.svg';
import chevronDownSmall from '../../../../assets/src/icon16/chevronDown.svg';
import chevronExpandSmall from '../../../../assets/src/icon16/chevronExpand.svg';
import chevronExpandSettings from '../../../../assets/src/icon16/chevronExpandSettings.svg';
import chevronLeftSmall from '../../../../assets/src/icon16/chevronLeft.svg';
import chevronRightSmall from '../../../../assets/src/icon16/chevronRight.svg';
import chevronUpSmall from '../../../../assets/src/icon16/chevronUp.svg';
import circleLineSmall from '../../../../assets/src/icon16/circleLine.svg';
import clearSmall from '../../../../assets/src/icon16/clear.svg';
import clock01Small from '../../../../assets/src/icon16/clock-1.svg';
import clockRewindSmall from '../../../../assets/src/icon16/clockRewind.svg';
import closeSmall from '../../../../assets/src/icon16/close.svg';
import codeSmall from '../../../../assets/src/icon16/code.svg';
import codeFilledSmall from '../../../../assets/src/icon16/codeFilled.svg';
import collapseSmall from '../../../../assets/src/icon16/collapse.svg';
import composeSmall from '../../../../assets/src/icon16/compose.svg';
import contactsSmall from '../../../../assets/src/icon16/contacts.svg';
import contactsFilledSmall from '../../../../assets/src/icon16/contactsFilled.svg';
import contentSmall from '../../../../assets/src/icon16/content.svg';
import copySmall from '../../../../assets/src/icon16/copy.svg';
import creditcardSmall from '../../../../assets/src/icon16/creditcard.svg';
import creditcardFilledSmall from '../../../../assets/src/icon16/creditcardFilled.svg';
import crossCircleSmall from '../../../../assets/src/icon16/crossCircle.svg';
import crownSmall from '../../../../assets/src/icon16/crown.svg';
import csatSmall from '../../../../assets/src/icon16/csat.svg';
import csatFilledSmall from '../../../../assets/src/icon16/csatFilled.svg';
import customerPortalSmall from '../../../../assets/src/icon16/customerPortal.svg';
import customerPortalFilledSmall from '../../../../assets/src/icon16/customerPortalFilled.svg';
import customFieldsSmall from '../../../../assets/src/icon16/customFields.svg';
import customFieldsFilledSmall from '../../../../assets/src/icon16/customFieldsFilled.svg';
import customViewsSmall from '../../../../assets/src/icon16/customViews.svg';
import customViewsFilledSmall from '../../../../assets/src/icon16/customViewsFilled.svg';
import dateSmall from '../../../../assets/src/icon16/date.svg';
import dateFilledSmall from '../../../../assets/src/icon16/dateFilled.svg';
import delegationFilledSmall from '../../../../assets/src/icon16/delegationFilled.svg';
import diamondSmall from '../../../../assets/src/icon16/diamond.svg';
import diamondFilledSmall from '../../../../assets/src/icon16/diamondFilled.svg';
import discussionSmall from '../../../../assets/src/icon16/discussion.svg';
import discussionFilledSmall from '../../../../assets/src/icon16/discussionFilled.svg';
import donotdisturbSmall from '../../../../assets/src/icon16/donotdisturb.svg';
import downloadSmall from '../../../../assets/src/icon16/download.svg';
import downloadFilledSmall from '../../../../assets/src/icon16/downloadFilled.svg';
import downloadLineSmall from '../../../../assets/src/icon16/downloadLine.svg';
import draftSmall from '../../../../assets/src/icon16/draft.svg';
import draftFilledSmall from '../../../../assets/src/icon16/draftFilled.svg';
import dropOffSmall from '../../../../assets/src/icon16/dropOff.svg';
import duplicateCopiesSmall from '../../../../assets/src/icon16/duplicateCopies.svg';
import dynamicVariableSmall from '../../../../assets/src/icon16/dynamicVariable.svg';
import dynamicVariableFilledSmall from '../../../../assets/src/icon16/dynamicVariableFilled.svg';
import editSmall from '../../../../assets/src/icon16/edit.svg';
import emojiSmall from '../../../../assets/src/icon16/emoji.svg';
import flagSmall from '../../../../assets/src/icon16/emojiFlags.svg';
import emojiPlaceholderSmall from '../../../../assets/src/icon16/emojiPlaceholder.svg';
import expandSmall from '../../../../assets/src/icon16/expand.svg';
import exportSmall from '../../../../assets/src/icon16/export.svg';
import externalLinkSmall from '../../../../assets/src/icon16/externalLink.svg';
import eyeSmall from '../../../../assets/src/icon16/eye.svg';
import eyeCrossedSmall from '../../../../assets/src/icon16/eyeCrossed.svg';
import eyeCrossedFilledSmall from '../../../../assets/src/icon16/eyeCrossedFilled.svg';
import eyeFilledSmall from '../../../../assets/src/icon16/eyeFilled.svg';
import facebookSmall from '../../../../assets/src/icon16/facebook.svg';
import featherSmall from '../../../../assets/src/icon16/feather.svg';
import featherFilledSmall from '../../../../assets/src/icon16/featherFilled.svg';
import file05Small from '../../../../assets/src/icon16/file-05.svg';
import filtersSmall from '../../../../assets/src/icon16/filters.svg';
import filtersFilledSmall from '../../../../assets/src/icon16/filtersFilled.svg';
import fireSmall from '../../../../assets/src/icon16/fire.svg';
import firstPageSmall from '../../../../assets/src/icon16/firstPage.svg';
import folderSmall from '../../../../assets/src/icon16/folder.svg';
import formattingBoldSmall from '../../../../assets/src/icon16/formattingBold.svg';
import formattingListSmall from '../../../../assets/src/icon16/formattingBullets.svg';
import formattingColorSmall from '../../../../assets/src/icon16/formattingColor.svg';
import formattingHighlightSmall from '../../../../assets/src/icon16/formattingHighlight.svg';
import formattingItalicSmall from '../../../../assets/src/icon16/formattingItalics.svg';
import formattingLinkSmall from '../../../../assets/src/icon16/formattingLink.svg';
import formattingNumberedListSmall from '../../../../assets/src/icon16/formattingNumberedList.svg';
import formattingBlockquoteSmall from '../../../../assets/src/icon16/formattingQuote.svg';
import formattingRemoveSmall from '../../../../assets/src/icon16/formattingRemove.svg';
import formattingStrikethroughSmall from '../../../../assets/src/icon16/formattingStrikethrough.svg';
import formattingUnderlineSmall from '../../../../assets/src/icon16/formattingUnderline.svg';
import forwardSmall from '../../../../assets/src/icon16/forward.svg';
import forwardAsNewSmall from '../../../../assets/src/icon16/forwardAsNew.svg';
import forwardFilled from '../../../../assets/src/icon16/forwardFilled.svg';
import gearSmall from '../../../../assets/src/icon16/gear.svg';
import gearFilledSmall from '../../../../assets/src/icon16/gearFilled.svg';
import gifSmall from '../../../../assets/src/icon16/gif.svg';
import giftSmall from '../../../../assets/src/icon16/gift.svg';
import globeSmall from '../../../../assets/src/icon16/globe.svg';
import globeFilledSmall from '../../../../assets/src/icon16/globeFilled.svg';
import glossaryLineSmall from '../../../../assets/src/icon16/glossaryLine.svg';
import grabHandleSmall from '../../../../assets/src/icon16/grabhandle.svg';
import graduationCapFilledSmall from '../../../../assets/src/icon16/graduationCapFilled.svg';
import grammarSmall from '../../../../assets/src/icon16/grammar.svg';
import groupSmall from '../../../../assets/src/icon16/group.svg';
import groupOutlineSmall from '../../../../assets/src/icon16/groupOutline.svg';
import helpSmall from '../../../../assets/src/icon16/help.svg';
import helpFilledSmall from '../../../../assets/src/icon16/helpFilled.svg';
import helpFullsizeFilledSmall from '../../../../assets/src/icon16/helpFullsizeFilled.svg';
import homeSmall from '../../../../assets/src/icon16/home.svg';
import homeFilledSmall from '../../../../assets/src/icon16/homeFilled.svg';
import imageSmall from '../../../../assets/src/icon16/image.svg';
import inboxSmall from '../../../../assets/src/icon16/inbox.svg';
import inbox01Small from '../../../../assets/src/icon16/inbox-01.svg';
import inboxDeliverabilitySmall from '../../../../assets/src/icon16/inboxDeliverability.svg';
import inboxDeliverabilityFilledSmall from '../../../../assets/src/icon16/inboxDeliverabilityFilled.svg';
import inboxFilledSmall from '../../../../assets/src/icon16/inboxFilled.svg';
import inboxListSmall from '../../../../assets/src/icon16/inboxList.svg';
import inboxListFilledSmall from '../../../../assets/src/icon16/inboxListFilled.svg';
import infoSmall from '../../../../assets/src/icon16/info.svg';
import infoFilledSmall from '../../../../assets/src/icon16/infoFilled.svg';
import integrationsSmall from '../../../../assets/src/icon16/integrations.svg';
import integrationsFilledSmall from '../../../../assets/src/icon16/integrationsFilled.svg';
import intercomSmall from '../../../../assets/src/icon16/intercom.svg';
import karlitoSmall from '../../../../assets/src/icon16/karlito.svg';
import knowledgeBaseSmall from '../../../../assets/src/icon16/knowledgeBase.svg';
import knowledgeBaseFilledSmall from '../../../../assets/src/icon16/knowledgeBaseFilled.svg';
import languageSmall from '../../../../assets/src/icon16/language.svg';
import lastPageSmall from '../../../../assets/src/icon16/lastPage.svg';
import lightbulbSmall from '../../../../assets/src/icon16/lightbulb.svg';
import lightningSmall from '../../../../assets/src/icon16/lightning.svg';
import lightningFilledSmall from '../../../../assets/src/icon16/lightningFilled.svg';
import lightThemeSmall from '../../../../assets/src/icon16/lightTheme.svg';
import linkSmall from '../../../../assets/src/icon16/link.svg';
import linkedConversationsSmall from '../../../../assets/src/icon16/linkedConversations.svg';
import linkedConversationsFilledSmall from '../../../../assets/src/icon16/linkedConversationsFilled.svg';
import linkedSmall from '../../../../assets/src/icon16/linking.svg';
import linkedFilledSmall from '../../../../assets/src/icon16/linkingFilled.svg';
import linkToOriginalSmall from '../../../../assets/src/icon16/linkToOriginal.svg';
import linkToOriginalFilledSmall from '../../../../assets/src/icon16/linkToOriginalFilled.svg';
import listSmall from '../../../../assets/src/icon16/list.svg';
import listFilledSmall from '../../../../assets/src/icon16/listFilled.svg';
import locationSmall from '../../../../assets/src/icon16/location.svg';
import lockSmall from '../../../../assets/src/icon16/lock.svg';
import lockOutlineSmall from '../../../../assets/src/icon16/lockOutline.svg';
import meetingBufferSmall from '../../../../assets/src/icon16/meetingBuffer.svg';
import meetingBuildingSmall from '../../../../assets/src/icon16/meetingBuilding.svg';
import meetingRoomSmall from '../../../../assets/src/icon16/meetingRoom.svg';
import mentionSmall from '../../../../assets/src/icon16/mention.svg';
import mentionFilledSmall from '../../../../assets/src/icon16/mentionFilled.svg';
import mergeSmall from '../../../../assets/src/icon16/merge.svg';
import mergeFilledSmall from '../../../../assets/src/icon16/mergeFilled.svg';
import messageSmall from '../../../../assets/src/icon16/message.svg';
import messageTemplateSmall from '../../../../assets/src/icon16/messageTemplate.svg';
import messageTemplateFilledSmall from '../../../../assets/src/icon16/messageTemplateFilled.svg';
import minusSmall from '../../../../assets/src/icon16/minus.svg';
import moonFilledSmall from '../../../../assets/src/icon16/moonFilled.svg';
import moreSmall from '../../../../assets/src/icon16/moreHorizontal.svg';
import moreVerticalSmall from '../../../../assets/src/icon16/moreVertical.svg';
import moveRightSmall from '../../../../assets/src/icon16/moveRight.svg';
import moveRightFilledSmall from '../../../../assets/src/icon16/moveRightFilled.svg';
import muteSmall from '../../../../assets/src/icon16/mute.svg';
import newSmall from '../../../../assets/src/icon16/new.svg';
import newAccountSmall from '../../../../assets/src/icon16/newAccount.svg';
import newContactSmall from '../../../../assets/src/icon16/newContact.svg';
import newGroupSmall from '../../../../assets/src/icon16/newGroup.svg';
import newMessageSmall from '../../../../assets/src/icon16/newMessage.svg';
import noneSmall from '../../../../assets/src/icon16/none.svg';
import noTagSmall from '../../../../assets/src/icon16/noTag.svg';
import notAssignSmall from '../../../../assets/src/icon16/notAssign.svg';
import noteSmall from '../../../../assets/src/icon16/note.svg';
import notesSmall from '../../../../assets/src/icon16/notes.svg';
import notificationSmall from '../../../../assets/src/icon16/notification.svg';
import notificationStrokeSmall from '../../../../assets/src/icon16/notificationStroke.svg';
import numbersSmall from '../../../../assets/src/icon16/numbers.svg';
import offlineFilledSmall from '../../../../assets/src/icon16/offlineFilled.svg';
import ongoingRequestSmall from '../../../../assets/src/icon16/ongoingRequest.svg';
import openSmall from '../../../../assets/src/icon16/open.svg';
import open01Small from '../../../../assets/src/icon16/open-01.svg';
import openSmallFilled from '../../../../assets/src/icon16/open-filled.svg';
import optionalGuestSmall from '../../../../assets/src/icon16/optionalGuest.svg';
import optionalGuestFilledSmall from '../../../../assets/src/icon16/optionalGuestFilled.svg';
import outboxSmall from '../../../../assets/src/icon16/outbox.svg';
import outboxFilledSmall from '../../../../assets/src/icon16/outboxFilled.svg';
import palmtreeSmall from '../../../../assets/src/icon16/palmtree.svg';
import palmtreeFilledSmall from '../../../../assets/src/icon16/palmtreeFilled.svg';
import participantSmall from '../../../../assets/src/icon16/participant.svg';
import participantFilledSmall from '../../../../assets/src/icon16/participantFilled.svg';
import personSpeakingSmall from '../../../../assets/src/icon16/personSpeaking.svg';
import phishingSmall from '../../../../assets/src/icon16/phishing.svg';
import phoneSmall from '../../../../assets/src/icon16/phone.svg';
import pinSmall from '../../../../assets/src/icon16/pin.svg';
import pinFilledSmall from '../../../../assets/src/icon16/pinFilled.svg';
import pinOutlineSmall from '../../../../assets/src/icon16/pinOutline.svg';
import plusSmall from '../../../../assets/src/icon16/plus.svg';
import plusCircleSmall from '../../../../assets/src/icon16/plusCircle.svg';
import plusCircleFilledSmall from '../../../../assets/src/icon16/plusCircleFilled.svg';
import popoutSmall from '../../../../assets/src/icon16/popout.svg';
import preferencesSmall from '../../../../assets/src/icon16/preferences.svg';
import preferencesFilledSmall from '../../../../assets/src/icon16/preferencesFilled.svg';
import printSmall from '../../../../assets/src/icon16/print.svg';
import questionmarkMaybe from '../../../../assets/src/icon16/questionmarkMaybe.svg';
import questionmarkMaybeSmall from '../../../../assets/src/icon16/questionmarkMaybe.svg';
import readSmall from '../../../../assets/src/icon16/read.svg';
import removeIntegrationsSmall from '../../../../assets/src/icon16/removeIntegrations.svg';
import repeatSmall from '../../../../assets/src/icon16/repeat.svg';
import repeatCircleSmall from '../../../../assets/src/icon16/repeatCircle.svg';
import replaceAllSmall from '../../../../assets/src/icon16/replaceAll.svg';
import repliedSmall from '../../../../assets/src/icon16/replied.svg';
import replySmall from '../../../../assets/src/icon16/reply.svg';
import replyAllSmall from '../../../../assets/src/icon16/replyAll.svg';
import replyFilledSmall from '../../../../assets/src/icon16/replyFilled.svg';
import requiredGuestSmall from '../../../../assets/src/icon16/requiredGuest.svg';
import resendAsNewSmall from '../../../../assets/src/icon16/resendAsNew.svg';
import retrySmall from '../../../../assets/src/icon16/retry.svg';
import retweetSmall from '../../../../assets/src/icon16/retweet.svg';
import reviewedSmall from '../../../../assets/src/icon16/reviewed.svg';
import rocketFilledSmall from '../../../../assets/src/icon16/rocketFilled.svg';
import ruleTest from '../../../../assets/src/icon16/ruleTest.svg';
import savedFlowOutlineSmall from '../../../../assets/src/icon16/savedFlowOutlineSmall.svg';
import savedFlowSmall from '../../../../assets/src/icon16/savedFlowSmall.svg';
import savedViewSmall from '../../../../assets/src/icon16/savedViews.svg';
import savedViewFilledSmall from '../../../../assets/src/icon16/savedViewsFilled.svg';
import scheduleSmall from '../../../../assets/src/icon16/schedule.svg';
import scheduleFilledSmall from '../../../../assets/src/icon16/scheduleFilled.svg';
import searchSmall from '../../../../assets/src/icon16/search.svg';
import sendSmall from '../../../../assets/src/icon16/send.svg';
import send01Small from '../../../../assets/src/icon16/send-01.svg';
import sendFilledSmall from '../../../../assets/src/icon16/sendFilled.svg';
import sharedFilledSmall from '../../../../assets/src/icon16/sharedFilled.svg';
import sharedOutlineSmall from '../../../../assets/src/icon16/sharedOutline.svg';
import shiftsSmall from '../../../../assets/src/icon16/shifts.svg';
import sidebarFilledSmall from '../../../../assets/src/icon16/sidebarFilled.svg';
import slaSmall from '../../../../assets/src/icon16/sla.svg';
import slackSmall from '../../../../assets/src/icon16/slack.svg';
import slaFilledSmall from '../../../../assets/src/icon16/slaFilled.svg';
import smartQASmall from '../../../../assets/src/icon16/smartQA.svg';
import smartQAFilledSmall from '../../../../assets/src/icon16/smartQAFilled.svg';
import snoozeSmall from '../../../../assets/src/icon16/snooze.svg';
import snoozeFilledSmall from '../../../../assets/src/icon16/snoozeFilled.svg';
import sortSmall from '../../../../assets/src/icon16/sort.svg';
import spamSmall from '../../../../assets/src/icon16/spam.svg';
import spamFilledSmall from '../../../../assets/src/icon16/spamFilled.svg';
import sparklesAiSmall from '../../../../assets/src/icon16/sparklesAI.svg';
import sparklesAiFilledSmall from '../../../../assets/src/icon16/sparklesAIFilled.svg';
import splitSmall from '../../../../assets/src/icon16/split.svg';
import splitFilledSmall from '../../../../assets/src/icon16/splitFilled.svg';
import squareFilledSmall from '../../../../assets/src/icon16/squareFilled.svg';
import stageSmall from '../../../../assets/src/icon16/stage.svg';
import stageFilledSmall from '../../../../assets/src/icon16/stageFilled.svg';
import starSmall from '../../../../assets/src/icon16/star.svg';
import starFilledSmall from '../../../../assets/src/icon16/starFilled.svg';
import statusAssignedSmallFilled from '../../../../assets/src/icon16/status_assigned-filled.svg';
import statusAssignedSmallOutline from '../../../../assets/src/icon16/status_assigned-outline.svg';
import statusUnassignedSmallFilled from '../../../../assets/src/icon16/status_unassigned-filled.svg';
import statusUnassignedSmallOutline from '../../../../assets/src/icon16/status_unassigned-outline.svg';
import subConvoSmall from '../../../../assets/src/icon16/subConvo.svg';
import subConvoFilledSmall from '../../../../assets/src/icon16/subConvoFilled.svg';
import subscribeSmall from '../../../../assets/src/icon16/subscribe.svg';
import subscribeFilledSmall from '../../../../assets/src/icon16/subscribeFilled.svg';
import switchFilledSmall from '../../../../assets/src/icon16/switchFilled.svg';
import tableColumnSmall from '../../../../assets/src/icon16/tableColumn.svg';
import tableGridSmall from '../../../../assets/src/icon16/tableGrid.svg';
import tableGridFilledSmall from '../../../../assets/src/icon16/tableGridFilled.svg';
import tagSmall from '../../../../assets/src/icon16/tag.svg';
import tagFilledSmall from '../../../../assets/src/icon16/tagFilled.svg';
import tagIsNotFilledSmall from '../../../../assets/src/icon16/tagIsNotFilled.svg';
import tagsSmall from '../../../../assets/src/icon16/tags.svg';
import tagsFilledSmall from '../../../../assets/src/icon16/tagsFilled.svg';
import taskSmall from '../../../../assets/src/icon16/task.svg';
import taskFilledSmall from '../../../../assets/src/icon16/taskFilled.svg';
import teammateRoleSmall from '../../../../assets/src/icon16/teammateRole.svg';
import teammateRoleFilledSmall from '../../../../assets/src/icon16/teammateRoleFilled.svg';
import teammatesSmall from '../../../../assets/src/icon16/teammates.svg';
import teammatesFilledSmall from '../../../../assets/src/icon16/teammatesFilledP1.svg';
import templateSmall from '../../../../assets/src/icon16/template.svg';
import textExpandSmall from '../../../../assets/src/icon16/textExpand.svg';
import thumbsdownSmall from '../../../../assets/src/icon16/thumbsdown.svg';
import thumbsupSmall from '../../../../assets/src/icon16/thumbsup.svg';
import ticketFilled from '../../../../assets/src/icon16/ticketFilled.svg';
import ticketSmall from '../../../../assets/src/icon16/ticketSmall.svg';
import timeSmall from '../../../../assets/src/icon16/time.svg';
import timeFilledSmall from '../../../../assets/src/icon16/timeFilled.svg';
import togglesSmall from '../../../../assets/src/icon16/toggles.svg';
import togglesFilledSmall from '../../../../assets/src/icon16/togglesFilled.svg';
import topicSmall from '../../../../assets/src/icon16/topic.svg';
import topicFilledSmall from '../../../../assets/src/icon16/topicFilled.svg';
import translationSmall from '../../../../assets/src/icon16/translation.svg';
import trashSmall from '../../../../assets/src/icon16/trash.svg';
import trash01Small from '../../../../assets/src/icon16/trash-01.svg';
import trashFilledSmall from '../../../../assets/src/icon16/trashFilled.svg';
import twitterSmall from '../../../../assets/src/icon16/twitter.svg';
import unassignedSmall from '../../../../assets/src/icon16/unassigned.svg';
import unassignedFilledSmall from '../../../../assets/src/icon16/unassignedFilled.svg';
import unlinkSmall from '../../../../assets/src/icon16/unlink.svg';
import unlinkedConversationsSmall from '../../../../assets/src/icon16/unlinkedConversations.svg';
import unlinkedConversationsFilledSmall from '../../../../assets/src/icon16/unlinkedConversationsFilled.svg';
import unpinOutlineSmall from '../../../../assets/src/icon16/unpinOutline.svg';
import userCircle02Small from '../../../../assets/src/icon16/user-circle-02.svg';
import variableSmall from '../../../../assets/src/icon16/variable.svg';
import verifiedFilledSmall from '../../../../assets/src/icon16/verifiedFilled.svg';
import videoSmall from '../../../../assets/src/icon16/video.svg';
import visitorSourceUrlSmall from '../../../../assets/src/icon16/visitorSourceUrl.svg';
import voicemailSmall from '../../../../assets/src/icon16/voicemail.svg';
import warningFilledSmall from '../../../../assets/src/icon16/warningFilled.svg';
import whatsappSmall from '../../../../assets/src/icon16/whatsapp.svg';
import workspaceSmall from '../../../../assets/src/icon16/workspace.svg';
import workspaceFilledSmall from '../../../../assets/src/icon16/workspaceFilled.svg';
import analytics from '../../../../assets/src/icon20/analytics.svg';
import archive from '../../../../assets/src/icon20/archive.svg';
import article from '../../../../assets/src/icon20/article.svg';
import assign from '../../../../assets/src/icon20/assign.svg';
import attachment from '../../../../assets/src/icon20/attachment.svg';
import auditTrail from '../../../../assets/src/icon20/auditTrail.svg';
import bell from '../../../../assets/src/icon20/bell.svg';
import blocks from '../../../../assets/src/icon20/blocks.svg';
import briefcaseFilled from '../../../../assets/src/icon20/briefcaseFilled.svg';
import briefcaseOutline from '../../../../assets/src/icon20/briefcaseOutline.svg';
import buildingFilled from '../../../../assets/src/icon20/buildingFilled.svg';
import buildingFilledCompany from '../../../../assets/src/icon20/buildingFilledCompany.svg';
import businessHoursFilled from '../../../../assets/src/icon20/businesshoursFilled.svg';
import calendar from '../../../../assets/src/icon20/calendar.svg';
import calendarFilled from '../../../../assets/src/icon20/calendarFilled.svg';
import calendarInvite from '../../../../assets/src/icon20/calendarInvite.svg';
import calendars from '../../../../assets/src/icon20/calendars.svg';
import callOutlined from '../../../../assets/src/icon20/callOutlined.svg';
import changeStatus from '../../../../assets/src/icon20/changeStatus.svg';
import changeStatusFilled from '../../../../assets/src/icon20/changeStatusFilled.svg';
import channelCallFilled from '../../../../assets/src/icon20/channelCallFilled.svg';
import channelChat from '../../../../assets/src/icon20/channelChat.svg';
import channelEmail from '../../../../assets/src/icon20/channelEmail.svg';
import channels from '../../../../assets/src/icon20/channels.svg';
import channelsFilled from '../../../../assets/src/icon20/channelsFilled.svg';
import chat from '../../../../assets/src/icon20/chat.svg';
import chatFilled from '../../../../assets/src/icon20/chatFilled.svg';
import checkmark from '../../../../assets/src/icon20/checkmark.svg';
import chevron from '../../../../assets/src/icon20/chevron.svg';
import chevronRight from '../../../../assets/src/icon20/chevronRight.svg';
import clock from '../../../../assets/src/icon20/clock.svg';
import close from '../../../../assets/src/icon20/close.svg';
import code from '../../../../assets/src/icon20/code.svg';
import collapse from '../../../../assets/src/icon20/collapse.svg';
import compose from '../../../../assets/src/icon20/compose.svg';
import composeFilled from '../../../../assets/src/icon20/composeFilled.svg';
import contacts from '../../../../assets/src/icon20/contacts.svg';
import contactsCutout from '../../../../assets/src/icon20/contactsCutout.svg';
import contactsFilled from '../../../../assets/src/icon20/contactsFilled.svg';
import contactsOutline from '../../../../assets/src/icon20/contactsOutline.svg';
import contentIcon from '../../../../assets/src/icon20/content.svg';
import copy from '../../../../assets/src/icon20/copy.svg';
import csatFilled from '../../../../assets/src/icon20/csatFilled.svg';
import customerPortalFilled from '../../../../assets/src/icon20/customerPortalFilled.svg';
import customFieldsFilled from '../../../../assets/src/icon20/customFieldsFilled.svg';
import customViews from '../../../../assets/src/icon20/customViews.svg';
import customViewsFilled from '../../../../assets/src/icon20/customViewsFilled.svg';
import date from '../../../../assets/src/icon20/date.svg';
import dateFilled from '../../../../assets/src/icon20/dateFilled.svg';
import developers from '../../../../assets/src/icon20/developers.svg';
import dotsGrid from '../../../../assets/src/icon20/dotsGrid.svg';
import download from '../../../../assets/src/icon20/download.svg';
import draft from '../../../../assets/src/icon20/draft.svg';
import dropdownNew from '../../../../assets/src/icon20/dropdownNew.svg';
import dropdownNewInbox from '../../../../assets/src/icon20/dropdownNewInbox.svg';
import dropdownNewLink from '../../../../assets/src/icon20/dropdownNewLink.svg';
import dropdownNewTag from '../../../../assets/src/icon20/dropdownNewTag.svg';
import dropdownUnassign from '../../../../assets/src/icon20/dropdownUnassign.svg';
import dynamicVariable from '../../../../assets/src/icon20/dynamicVariable.svg';
import dynamicVariableFilled from '../../../../assets/src/icon20/dynamicVariableFilled.svg';
import edit from '../../../../assets/src/icon20/edit.svg';
import emoji from '../../../../assets/src/icon20/emoji.svg';
import emojiActivity from '../../../../assets/src/icon20/emojiActivity.svg';
import emojiFlags from '../../../../assets/src/icon20/emojiFlags.svg';
import emojiFood from '../../../../assets/src/icon20/emojiFood.svg';
import emojiNature from '../../../../assets/src/icon20/emojiNature.svg';
import emojiObjects from '../../../../assets/src/icon20/emojiObjects.svg';
import emojiPeople from '../../../../assets/src/icon20/emojiPeople.svg';
import emojiSymbols from '../../../../assets/src/icon20/emojiSymbols.svg';
import emojiTravel from '../../../../assets/src/icon20/emojiTravel.svg';
import endCallOutlined from '../../../../assets/src/icon20/endCallOutlined.svg';
import exit from '../../../../assets/src/icon20/exit.svg';
import expand from '../../../../assets/src/icon20/expand.svg';
import exportIcon from '../../../../assets/src/icon20/export.svg';
import externalLink from '../../../../assets/src/icon20/externalLink.svg';
import eye from '../../../../assets/src/icon20/eye.svg';
import feather from '../../../../assets/src/icon20/feather.svg';
import filters from '../../../../assets/src/icon20/filters.svg';
import folder from '../../../../assets/src/icon20/folder.svg';
import folderOutline from '../../../../assets/src/icon20/folderOutline.svg';
import formatting from '../../../../assets/src/icon20/formatting.svg';
import formattingBold from '../../../../assets/src/icon20/formattingBold.svg';
import formattingList from '../../../../assets/src/icon20/formattingBullets.svg';
import formattingColor from '../../../../assets/src/icon20/formattingColor.svg';
import formattingHighlight from '../../../../assets/src/icon20/formattingHighlight.svg';
import formattingImage from '../../../../assets/src/icon20/formattingImage.svg';
import formattingItalic from '../../../../assets/src/icon20/formattingItalics.svg';
import formattingLink from '../../../../assets/src/icon20/formattingLink.svg';
import formattingBlockquote from '../../../../assets/src/icon20/formattingQuote.svg';
import formattingRemove from '../../../../assets/src/icon20/formattingRemove.svg';
import formattingStrikethrough from '../../../../assets/src/icon20/formattingStrikethrough.svg';
import formattingUnderline from '../../../../assets/src/icon20/formattingUnderline.svg';
import forwardAudioFilled from '../../../../assets/src/icon20/forwardAudioFilled.svg';
import gear from '../../../../assets/src/icon20/gear.svg';
import gearFilled from '../../../../assets/src/icon20/gearFilled.svg';
import gif from '../../../../assets/src/icon20/gif.svg';
import goToConversation from '../../../../assets/src/icon20/goToConversation.svg';
import graduationCapOutlined from '../../../../assets/src/icon20/graduationCapOutlined.svg';
import group from '../../../../assets/src/icon20/group.svg';
import guide from '../../../../assets/src/icon20/guide.svg';
import help from '../../../../assets/src/icon20/help.svg';
import helpFilled from '../../../../assets/src/icon20/helpFilled.svg';
import helpIndicator from '../../../../assets/src/icon20/helpIndicator.svg';
import hideP1 from '../../../../assets/src/icon20/hideP1.svg';
import history from '../../../../assets/src/icon20/history.svg';
import hold from '../../../../assets/src/icon20/hold.svg';
import holdFilled from '../../../../assets/src/icon20/holdFilled.svg';
import homeFilled from '../../../../assets/src/icon20/homeFilled.svg';
import horizontalRule from '../../../../assets/src/icon20/horizontalRule.svg';
import imagesEmpty from '../../../../assets/src/icon20/imagesEmpty.svg';
import inbox from '../../../../assets/src/icon20/inbox.svg';
import inboxFilled from '../../../../assets/src/icon20/inboxFilled.svg';
import inflowInbox from '../../../../assets/src/icon20/inflowInbox.svg';
import info from '../../../../assets/src/icon20/info.svg';
import infoFilled from '../../../../assets/src/icon20/infoFilled.svg';
import infoHistory from '../../../../assets/src/icon20/infoHistory.svg';
import integration from '../../../../assets/src/icon20/integration.svg';
import integrationsFilled from '../../../../assets/src/icon20/integrationsFilled.svg';
import keyboard from '../../../../assets/src/icon20/keyboard.svg';
import keypad from '../../../../assets/src/icon20/keypad.svg';
import keypadFilled from '../../../../assets/src/icon20/keypadFilled.svg';
import knowledgeBase from '../../../../assets/src/icon20/knowledgeBase.svg';
import knowledgeBaseFilled from '../../../../assets/src/icon20/knowledgeBaseFilled.svg';
import knowledgeBaseOutlined from '../../../../assets/src/icon20/knowledgeBaseOutlined.svg';
import lightbulb from '../../../../assets/src/icon20/lightbulb.svg';
import lightning from '../../../../assets/src/icon20/lightning.svg';
import lightningFilled from '../../../../assets/src/icon20/lightningFilled.svg';
import like from '../../../../assets/src/icon20/like.svg';
import likeFilled from '../../../../assets/src/icon20/likeFilled.svg';
import link from '../../../../assets/src/icon20/link.svg';
import linkedConversationsFilled from '../../../../assets/src/icon20/linkedConversationsFilled.svg';
import list from '../../../../assets/src/icon20/list.svg';
import listFilled from '../../../../assets/src/icon20/listFilled.svg';
import lock from '../../../../assets/src/icon20/lock.svg';
import lockFilled from '../../../../assets/src/icon20/lockFilled.svg';
import mention from '../../../../assets/src/icon20/mention.svg';
import menu from '../../../../assets/src/icon20/menu.svg';
import merge from '../../../../assets/src/icon20/merge.svg';
import message from '../../../../assets/src/icon20/message.svg';
import messageTemplate from '../../../../assets/src/icon20/messageTemplate.svg';
import messageTemplateFilled from '../../../../assets/src/icon20/messageTemplateFilled.svg';
import more from '../../../../assets/src/icon20/more.svg';
import moreVertical from '../../../../assets/src/icon20/moreVertical.svg';
import moveActivityFilled from '../../../../assets/src/icon20/moveActivityFilled.svg';
import moveRightFilled from '../../../../assets/src/icon20/moveRightFilled.svg';
import mute from '../../../../assets/src/icon20/mute.svg';
import muteFilled from '../../../../assets/src/icon20/muteFilled.svg';
import newIcon from '../../../../assets/src/icon20/new.svg';
import newContact from '../../../../assets/src/icon20/newContact.svg';
import newEvent from '../../../../assets/src/icon20/newevent.svg';
import none from '../../../../assets/src/icon20/none.svg';
import numbers from '../../../../assets/src/icon20/numbers.svg';
import openPanel from '../../../../assets/src/icon20/openPanel.svg';
import outbox from '../../../../assets/src/icon20/outbox.svg';
import palmTree from '../../../../assets/src/icon20/palmtree.svg';
import pauseFilled from '../../../../assets/src/icon20/pauseFilled.svg';
import personFilled from '../../../../assets/src/icon20/personFilled.svg';
import phone from '../../../../assets/src/icon20/phone.svg';
import planet from '../../../../assets/src/icon20/planet.svg';
import playFilled from '../../../../assets/src/icon20/playFilled.svg';
import plusCircle from '../../../../assets/src/icon20/plusCircle.svg';
import popin from '../../../../assets/src/icon20/popin.svg';
import popout from '../../../../assets/src/icon20/popout.svg';
import questionMark from '../../../../assets/src/icon20/questionMark.svg';
import reminder from '../../../../assets/src/icon20/reminder.svg';
import removeIntegration from '../../../../assets/src/icon20/removeIntegration.svg';
import reopen from '../../../../assets/src/icon20/reopen.svg';
import repeatCircle from '../../../../assets/src/icon20/repeatCircle.svg';
import replayAudioFilled from '../../../../assets/src/icon20/replayAudioFilled.svg';
import reply from '../../../../assets/src/icon20/reply.svg';
import replyAll from '../../../../assets/src/icon20/replyAll.svg';
import replyFilled from '../../../../assets/src/icon20/replyFilled.svg';
import resnooze from '../../../../assets/src/icon20/resnooze.svg';
import restore from '../../../../assets/src/icon20/restore.svg';
import retweet from '../../../../assets/src/icon20/retweet.svg';
import retweeted from '../../../../assets/src/icon20/retweeted.svg';
import rocketFilled from '../../../../assets/src/icon20/rocketFilled.svg';
import save from '../../../../assets/src/icon20/save.svg';
import savedFlow from '../../../../assets/src/icon20/savedFlow.svg';
import savedViewFilled from '../../../../assets/src/icon20/savedViewsFilled.svg';
import schedule from '../../../../assets/src/icon20/schedule.svg';
import scheduleFilled from '../../../../assets/src/icon20/scheduleFilled.svg';
import search from '../../../../assets/src/icon20/search.svg';
import section from '../../../../assets/src/icon20/section.svg';
import sectionFilled from '../../../../assets/src/icon20/sectionFilled.svg';
import send from '../../../../assets/src/icon20/send.svg';
import sendFilled from '../../../../assets/src/icon20/sendFilled.svg';
import sequences from '../../../../assets/src/icon20/sequences.svg';
import settings from '../../../../assets/src/icon20/settings.svg';
import sidePane from '../../../../assets/src/icon20/sidePane.svg';
import sla from '../../../../assets/src/icon20/sla.svg';
import slaFilled from '../../../../assets/src/icon20/slaFilled.svg';
import smartQAFilled from '../../../../assets/src/icon20/smartQAFilled.svg';
import snooze from '../../../../assets/src/icon20/snooze.svg';
import snoozeFilled from '../../../../assets/src/icon20/snoozeFilled.svg';
import spam from '../../../../assets/src/icon20/spam.svg';
import spamFilled from '../../../../assets/src/icon20/spamFilled.svg';
import sparklesAi from '../../../../assets/src/icon20/sparklesAI.svg';
import sparklesAiFilled from '../../../../assets/src/icon20/sparklesAIFilled.svg';
import stageFilled from '../../../../assets/src/icon20/stageFilled.svg';
import star from '../../../../assets/src/icon20/star.svg';
import starFilled from '../../../../assets/src/icon20/starFilled.svg';
import subscribed from '../../../../assets/src/icon20/subscribed.svg';
import table from '../../../../assets/src/icon20/table.svg';
import tableColumn from '../../../../assets/src/icon20/tableColumn.svg';
import tableGrid from '../../../../assets/src/icon20/tableGrid.svg';
import tableGridFilled from '../../../../assets/src/icon20/tableGridFilled.svg';
import tag from '../../../../assets/src/icon20/tag.svg';
import tagFilled from '../../../../assets/src/icon20/tagFilled.svg';
import tags from '../../../../assets/src/icon20/tags.svg';
import taskLarge from '../../../../assets/src/icon20/task.svg';
import teammateFilled from '../../../../assets/src/icon20/teammateFilled.svg';
import teammateRole from '../../../../assets/src/icon20/teammateRole.svg';
import teammates from '../../../../assets/src/icon20/teammates.svg';
import teammatesFilled from '../../../../assets/src/icon20/teammatesFilled.svg';
import template from '../../../../assets/src/icon20/template.svg';
import thumbsup from '../../../../assets/src/icon20/thumbsup.svg';
import toggles from '../../../../assets/src/icon20/toggles.svg';
import togglesFilled from '../../../../assets/src/icon20/togglesFilled.svg';
import trash from '../../../../assets/src/icon20/trash.svg';
import trashFilled from '../../../../assets/src/icon20/trashFilled.svg';
import twitterFilled from '../../../../assets/src/icon20/twitterFilled.svg';
import unassign from '../../../../assets/src/icon20/unassign.svg';
import unassignedFilled from '../../../../assets/src/icon20/unassignedFilled.svg';
import unlink from '../../../../assets/src/icon20/unlink.svg';
import unlinkedConversationsFilled from '../../../../assets/src/icon20/unlinkedConversationsFilled.svg';
import untag from '../../../../assets/src/icon20/untag.svg';
import variable from '../../../../assets/src/icon20/variable.svg';
import video from '../../../../assets/src/icon20/video.svg';
import visitorSourceUrl from '../../../../assets/src/icon20/visitorSourceUrl.svg';
import volumeAudioFilled from '../../../../assets/src/icon20/volumeAudioFilled.svg';
import warningFilledTriangle from '../../../../assets/src/icon20/warningFilledTriangle.svg';
import {webIcons as newIcons} from '../../../../assets/src/icons';
import backspaceOutlined from '../../../../assets/src/icons/backspaceOutlined.svg';
import calendarSelected from '../../../../assets/src/icons/calendarSelected.svg';
import callFilled from '../../../../assets/src/icons/callFilled.svg';
import checkmarkCircleLarge from '../../../../assets/src/icons/checkmarkCircle.svg';
import crossCircle from '../../../../assets/src/icons/crossCircle.svg';
import csatSurvey from '../../../../assets/src/icons/csat.svg';
import downloadCircle from '../../../../assets/src/icons/download.svg';
import externalLinkCircle from '../../../../assets/src/icons/externalLinkCircle.svg';
import folderLarge from '../../../../assets/src/icons/folder.svg';
import loaderRetry from '../../../../assets/src/icons/loaderRetry.svg';
import loaderRetrySmall from '../../../../assets/src/icons/loaderRetrySmall.svg';
import messageTemplateLarge from '../../../../assets/src/icons/messageTemplate.svg';
import replyArrow from '../../../../assets/src/icons/replyArrow.svg';
import shiftScheduleFilledSmall from '../../../../assets/src/icons/schedule/schedule-filled-16.svg';
import shiftScheduleSmall from '../../../../assets/src/icons/schedule/schedule-outlined-16.svg';
import wfmFilledSmall from '../../../../assets/src/icons/shift/shift-filled-16.svg';
import wfmSmall from '../../../../assets/src/icons/shift/shift-outlined-16.svg';
import targetOffSmall from '../../../../assets/src/icons/target-off/target-off-outlined-16.svg';
import windowsClose from '../../../../assets/src/icons/windowsClose.svg';
import windowsMaximize from '../../../../assets/src/icons/windowsMaximize.svg';
import windowsMinimize from '../../../../assets/src/icons/windowsMinimize.svg';
import windowsUnmaximize from '../../../../assets/src/icons/windowsUnmaximize.svg';
import {buildCleanReactInnerHtml} from '../../../../core/src/helpers/typescript/cleanHtml';
import {useSvgContent} from '../svg/useSvgContent';
import {IconColor, isIconColor, resolveIconColor} from './iconColor';
import {buildIconAttributes, buildSvgAssetMap} from './iconHelpers';
import {legacyIconMap} from './legacyIconMap';

const importedIcons = buildSvgAssetMap({
  publicApiTiny: publicApiTiny,
  autoContactFilledTiny: autoContactFilledTiny,
  bellTiny: bellTiny,
  busyFilledTiny: busyFilledTiny,
  checkmarkBoxTiny: checkmarkBoxTiny,
  chevronDownTiny: chevronDownTiny,
  chevronExpandTiny: chevronExpandTiny,
  chevronCollapseTiny: chevronCollapseTiny,
  chevronRightTiny: chevronRightTiny,
  clockTiny: clockTiny,
  closeTiny: closeTiny,
  copyTiny: copyTiny,
  diamondFilledTiny: diamondFilledTiny,
  downloadTiny: downloadTiny,
  draftFilledTiny: draftFilledTiny,
  editTiny: editTiny,
  exitTiny: exitTiny,
  externalLinkTiny: externalLinkTiny,
  frontLogoTiny: frontLogoTiny,
  gearFilledTiny: gearFilledTiny,
  lightbulbTiny: lightbulbTiny,
  lightningTiny: lightningTiny,
  linkedConversationsTiny: linkedConversationsTiny,
  linkedConversationsFilledTiny: linkedConversationsFilledTiny,
  linkTiny: linkTiny,
  lockFilledNewTiny: lockFilledNewTiny,
  lockFilledTiny: lockFilledTiny,
  mutedStatusTiny: mutedStatusTiny,
  nestedArrowTiny: nestedArrowTiny,
  newTiny: newTiny,
  oooTiny: oooTiny,
  pinFilledTiny: pinFilledTiny,
  plusTiny: plusTiny,
  questionMarkTiny: questionMarkTiny,
  replyTiny: replyTiny,
  searchTiny: searchTiny,
  sharedFilledTiny: sharedFilledTiny,
  sparklesAiFilledTiny: sparklesAiFilledTiny,
  starTiny: starTiny,
  subscribeTiny: subscribeTiny,
  unsubscribeTiny: unsubscribeTiny,
  warningFilledTiny: warningFilledTiny,
  taskFilledTiny: taskFilledTiny,
  taskTiny: taskTiny,
  callQueuedActivity: callQueuedActivity,
  callAnsweredActivity: callAnsweredActivity,
  callEndedActivity: callEndedActivity,
  callOnHoldActivity: callOnHoldActivity,
  callResumedActivity: callResumedActivity,
  callTransferredActivity: callTransferredActivity,
  callMissedActivity: callMissedActivity,
  chatEndedActivity: chatEndedActivity,
  checkmarkYesActivity: checkmarkYesActivity,
  chatDeflected: chatDeflected,
  closedActivity: closedActivity,
  gearActivity: gearActivity,
  groupActivity: groupActivity,
  inboxActivity: inboxActivity,
  inboxInboundFilled: inboxInboundFilled,
  integrationActivity: integrationActivity,
  inviteActivity: inviteActivity,
  mergeActivity: mergeActivity,
  mergeActivityFilled: mergeActivityFilled,
  messageActivity: messageActivity,
  moveActivity: moveActivity,
  questionmarkMaybeActivity: questionmarkMaybeActivity,
  lightningActivity: lightningActivity,
  linkedConversationsFilledMedium: linkedConversationsFilledMedium,
  removeActivity: removeActivity,
  removeIntegrationActivity: removeIntegrationActivity,
  snoozeActivity: snoozeActivity,
  snoozeActivityFilled: snoozeActivityFilled,
  splitActivity: splitActivity,
  splitActivityFilled: splitActivityFilled,
  squareFilled: squareFilled,
  tagActivity: tagActivity,
  tagActivityFilled: tagActivityFilled,
  topicActivity: topicActivity,
  transcriptActivity: transcriptActivity,
  trashActivity: trashActivity,
  unarchiveActivityFilled: unarchiveActivityFilled,
  unassignActivity: unassignActivity,
  unassignActivityFilled: unassignActivityFilled,
  unlinkedConversationsActivity: unlinkedConversationsActivity,
  untagActivity: untagActivity,
  untagActivityFilled: untagActivityFilled,
  warningActivity: warningActivity,
  xNoActivity: xNoActivity,
  taskFilled: taskFilled,
  task: task,
  attachmentSmall: attachmentSmall,
  auditLogFilledSmall: auditLogFilledSmall,
  auditLogSmall: auditLogSmall,
  autoContactFilledSmall: autoContactFilledSmall,
  autoContactSmall: autoContactSmall,
  bellCrossedSmall: bellCrossedSmall,
  bellSmall: bellSmall,
  bell02Small: bell02Small,
  briefcaseFilledSmall: briefcaseFilledSmall,
  briefcaseOutlineSmall: briefcaseOutlineSmall,
  buildingFilledSmall: buildingFilledSmall,
  calendarFilledSmall: calendarFilledSmall,
  calendarSmall: calendarSmall,
  callInboundFilledSmall: callInboundFilledSmall,
  callMissedSmall: callMissedSmall,
  callOutboundFilledSmall: callOutboundFilledSmall,
  callOutlinedSmall: callOutlinedSmall,
  caseStudySmall: caseStudySmall,
  changeStatusFilledSmall: changeStatusFilledSmall,
  changeStatusSmall: changeStatusSmall,
  channelCallFilledSmall: channelCallFilledSmall,
  channelCallOutlineSmall: channelCallOutlineSmall,
  channelChatOutlineSmall: channelChatOutlineSmall,
  channelChatSmall: channelChatSmall,
  channelEmailOutlineSmall: channelEmailOutlineSmall,
  channelEmailSmall: channelEmailSmall,
  channelGooglePlayOutlineSmall: channelGooglePlayOutlineSmall,
  channelGooglePlaySmall: channelGooglePlaySmall,
  channelsFilledSmall: channelsFilledSmall,
  channelsSmall: channelsSmall,
  chatbotFilledSmall: chatbotFilledSmall,
  chatbotSmall: chatbotSmall,
  checkCircleSmall: checkCircleSmall,
  checkmarkBoxSmall: checkmarkBoxSmall,
  checkmarkCircleLarge: checkmarkCircleLarge,
  checkmarkCircleOutlineSmall: checkmarkCircleOutlineSmall,
  checkmarkCircleSmall: checkmarkCircleSmall,
  checkmarkSelectedSmall: checkmarkSelectedSmall,
  checkSmallFilled: checkSmallFilled,
  checkSmallOutline: checkSmallOutline,
  chevronCollapseSmall: chevronCollapseSmall,
  chevronDownSmall: chevronDownSmall,
  chevronExpandSettings: chevronExpandSettings,
  chevronExpandSmall: chevronExpandSmall,
  chevronLeftSmall: chevronLeftSmall,
  chevronRightSmall: chevronRightSmall,
  chevronUpSmall: chevronUpSmall,
  circleLineSmall: circleLineSmall,
  clearSmall: clearSmall,
  clock01Small: clock01Small,
  clockRewindSmall: clockRewindSmall,
  closeSmall: closeSmall,
  codeFilledSmall: codeFilledSmall,
  codeSmall: codeSmall,
  collapseSmall: collapseSmall,
  composeSmall: composeSmall,
  contactsFilledSmall: contactsFilledSmall,
  contactsSmall: contactsSmall,
  contentSmall: contentSmall,
  copySmall: copySmall,
  creditcardFilledSmall: creditcardFilledSmall,
  creditcardSmall: creditcardSmall,
  crossCircleSmall: crossCircleSmall,
  crownSmall: crownSmall,
  csatFilledSmall: csatFilledSmall,
  csatSmall: csatSmall,
  csatSurvey: csatSurvey,
  customerPortalFilledSmall: customerPortalFilledSmall,
  customerPortalSmall: customerPortalSmall,
  customFieldsActivity: customFieldsActivity,
  customFieldsFilled: customFieldsFilled,
  customFieldsFilledSmall: customFieldsFilledSmall,
  customFieldsSmall: customFieldsSmall,
  customViewsFilledSmall: customViewsFilledSmall,
  customViewsSmall: customViewsSmall,
  dateFilledSmall: dateFilledSmall,
  dateSmall: dateSmall,
  delegationFilledSmall: delegationFilledSmall,
  diamondFilledSmall: diamondFilledSmall,
  diamondSmall: diamondSmall,
  discussionFilledSmall: discussionFilledSmall,
  discussionSmall: discussionSmall,
  donotdisturbSmall: donotdisturbSmall,
  downloadFilledSmall: downloadFilledSmall,
  downloadLineSmall: downloadLineSmall,
  downloadSmall: downloadSmall,
  draftFilledSmall: draftFilledSmall,
  draftSmall: draftSmall,
  dropOffSmall: dropOffSmall,
  duplicateCopiesSmall: duplicateCopiesSmall,
  dynamicVariableFilledSmall: dynamicVariableFilledSmall,
  dynamicVariableSmall: dynamicVariableSmall,
  editSmall: editSmall,
  emojiPlaceholderSmall: emojiPlaceholderSmall,
  emojiSmall: emojiSmall,
  expandSmall: expandSmall,
  exportSmall: exportSmall,
  externalLinkSmall: externalLinkSmall,
  eyeCrossedFilledSmall: eyeCrossedFilledSmall,
  eyeCrossedSmall: eyeCrossedSmall,
  eyeFilledSmall: eyeFilledSmall,
  eyeSmall: eyeSmall,
  facebookSmall: facebookSmall,
  featherFilledSmall: featherFilledSmall,
  featherSmall: featherSmall,
  file05Small: file05Small,
  filtersFilledSmall: filtersFilledSmall,
  filtersSmall: filtersSmall,
  fireSmall: fireSmall,
  firstPageSmall: firstPageSmall,
  flagSmall: flagSmall,
  folderSmall: folderSmall,
  formattingBlockquoteSmall: formattingBlockquoteSmall,
  formattingBoldSmall: formattingBoldSmall,
  formattingColorSmall: formattingColorSmall,
  formattingHighlightSmall: formattingHighlightSmall,
  formattingItalicSmall: formattingItalicSmall,
  formattingLinkSmall: formattingLinkSmall,
  formattingNumberedListSmall: formattingNumberedListSmall,
  formattingRemoveSmall: formattingRemoveSmall,
  formattingStrikethroughSmall: formattingStrikethroughSmall,
  formattingUnderlineSmall: formattingUnderlineSmall,
  forwardAsNewSmall: forwardAsNewSmall,
  forwardFilled: forwardFilled,
  forwardSmall: forwardSmall,
  gearFilledSmall: gearFilledSmall,
  gearSmall: gearSmall,
  gifSmall: gifSmall,
  giftSmall: giftSmall,
  globeFilledSmall: globeFilledSmall,
  globeSmall: globeSmall,
  glossaryLineSmall: glossaryLineSmall,
  grabHandleSmall: grabHandleSmall,
  graduationCapFilledSmall: graduationCapFilledSmall,
  grammarSmall: grammarSmall,
  groupOutlineSmall: groupOutlineSmall,
  groupSmall: groupSmall,
  helpFilledSmall: helpFilledSmall,
  helpFullsizeFilledSmall: helpFullsizeFilledSmall,
  helpSmall: helpSmall,
  homeFilledSmall: homeFilledSmall,
  homeSmall: homeSmall,
  imageSmall: imageSmall,
  inbox01Small: inbox01Small,
  inboxDeliverabilityFilledSmall: inboxDeliverabilityFilledSmall,
  inboxDeliverabilitySmall: inboxDeliverabilitySmall,
  inboxFilledSmall: inboxFilledSmall,
  inboxListFilledSmall: inboxListFilledSmall,
  inboxListSmall: inboxListSmall,
  inboxSmall: inboxSmall,
  infoFilledSmall: infoFilledSmall,
  infoSmall: infoSmall,
  integrationsFilledSmall: integrationsFilledSmall,
  integrationsSmall: integrationsSmall,
  intercomSmall: intercomSmall,
  karlitoSmall: karlitoSmall,
  knowledgeBaseFilledSmall: knowledgeBaseFilledSmall,
  knowledgeBaseSmall: knowledgeBaseSmall,
  languageSmall: languageSmall,
  lastPageSmall: lastPageSmall,
  lightbulbSmall: lightbulbSmall,
  lightningFilledSmall: lightningFilledSmall,
  lightningSmall: lightningSmall,
  lightThemeSmall: lightThemeSmall,
  linkedConversationsFilledSmall: linkedConversationsFilledSmall,
  linkedConversationsSmall: linkedConversationsSmall,
  linkSmall: linkSmall,
  unlinkSmall: unlinkSmall,
  linkedSmall: linkedSmall,
  linkedFilledSmall: linkedFilledSmall,
  linkToOriginalSmall: linkToOriginalSmall,
  linkToOriginalFilledSmall: linkToOriginalFilledSmall,
  listFilledSmall: listFilledSmall,
  listSmall: listSmall,
  locationSmall: locationSmall,
  lockOutlineSmall: lockOutlineSmall,
  lockSmall: lockSmall,
  meetingBufferSmall: meetingBufferSmall,
  meetingBuildingSmall: meetingBuildingSmall,
  meetingRoomSmall: meetingRoomSmall,
  mentionFilledSmall: mentionFilledSmall,
  mentionSmall: mentionSmall,
  mergeFilledSmall: mergeFilledSmall,
  mergeSmall: mergeSmall,
  messageSmall: messageSmall,
  messageTemplateFilledSmall: messageTemplateFilledSmall,
  messageTemplateSmall: messageTemplateSmall,
  minusSmall: minusSmall,
  moonFilledSmall: moonFilledSmall,
  moreVerticalSmall: moreVerticalSmall,
  moveRightFilledSmall: moveRightFilledSmall,
  moveRightSmall: moveRightSmall,
  muteSmall: muteSmall,
  newAccountSmall: newAccountSmall,
  newContactSmall: newContactSmall,
  newGroupSmall: newGroupSmall,
  newMessageSmall: newMessageSmall,
  newSmall: newSmall,
  noneSmall: noneSmall,
  noTagSmall: noTagSmall,
  notAssignSmall: notAssignSmall,
  noteSmall: noteSmall,
  notesSmall: notesSmall,
  notificationSmall: notificationSmall,
  notificationStrokeSmall: notificationStrokeSmall,
  numbersSmall: numbersSmall,
  offlineFilledSmall: offlineFilledSmall,
  ongoingRequestSmall: ongoingRequestSmall,
  open01Small: open01Small,
  openSmall: openSmall,
  openSmallFilled: openSmallFilled,
  optionalGuestFilledSmall: optionalGuestFilledSmall,
  optionalGuestSmall: optionalGuestSmall,
  outboxFilledSmall: outboxFilledSmall,
  outboxSmall: outboxSmall,
  palmtreeFilledSmall: palmtreeFilledSmall,
  palmtreeSmall: palmtreeSmall,
  participantFilledSmall: participantFilledSmall,
  participantSmall: participantSmall,
  personSpeakingSmall: personSpeakingSmall,
  phishingSmall: phishingSmall,
  phoneSmall: phoneSmall,
  pinFilledSmall: pinFilledSmall,
  pinOutlineSmall: pinOutlineSmall,
  pinSmall: pinSmall,
  plusCircleFilledSmall: plusCircleFilledSmall,
  plusCircleSmall: plusCircleSmall,
  plusSmall: plusSmall,
  popoutSmall: popoutSmall,
  preferencesFilledSmall: preferencesFilledSmall,
  preferencesSmall: preferencesSmall,
  printSmall: printSmall,
  questionmarkMaybe: questionmarkMaybe,
  questionmarkMaybeSmall: questionmarkMaybeSmall,
  readSmall: readSmall,
  removeIntegrationsSmall: removeIntegrationsSmall,
  repeatCircleSmall: repeatCircleSmall,
  repeatSmall: repeatSmall,
  replaceAllSmall: replaceAllSmall,
  repliedSmall: repliedSmall,
  replyFilledSmall: replyFilledSmall,
  replySmall: replySmall,
  replyAllSmall: replyAllSmall,
  requiredGuestSmall: requiredGuestSmall,
  resendAsNewSmall: resendAsNewSmall,
  retrySmall: retrySmall,
  retweetSmall: retweetSmall,
  reviewedSmall: reviewedSmall,
  rocketFilledSmall: rocketFilledSmall,
  ruleTest: ruleTest,
  savedFlowOutlineSmall: savedFlowOutlineSmall,
  savedFlowSmall: savedFlowSmall,
  savedViewFilledSmall: savedViewFilledSmall,
  savedViewSmall: savedViewSmall,
  scheduleFilledSmall: scheduleFilledSmall,
  scheduleSmall: scheduleSmall,
  searchSmall: searchSmall,
  send01Small: send01Small,
  sendFilledSmall: sendFilledSmall,
  sendSmall: sendSmall,
  sharedFilledSmall: sharedFilledSmall,
  sharedOutlineSmall: sharedOutlineSmall,
  shiftsSmall: shiftsSmall,
  shiftScheduleFilledSmall: shiftScheduleFilledSmall,
  shiftScheduleSmall: shiftScheduleSmall,
  sidebarFilledSmall: sidebarFilledSmall,
  slaFilledSmall: slaFilledSmall,
  slaSmall: slaSmall,
  slackSmall: slackSmall,
  smartQAFilledSmall: smartQAFilledSmall,
  smartQASmall: smartQASmall,
  snoozeFilledSmall: snoozeFilledSmall,
  snoozeSmall: snoozeSmall,
  sortSmall: sortSmall,
  spamFilledSmall: spamFilledSmall,
  spamSmall: spamSmall,
  sparklesAiFilledSmall: sparklesAiFilledSmall,
  sparklesAiSmall: sparklesAiSmall,
  splitFilledSmall: splitFilledSmall,
  splitSmall: splitSmall,
  squareFilledSmall: squareFilledSmall,
  stageFilledSmall: stageFilledSmall,
  stageSmall: stageSmall,
  starFilledSmall: starFilledSmall,
  starSmall: starSmall,
  statusAssignedSmallFilled: statusAssignedSmallFilled,
  statusAssignedSmallOutline: statusAssignedSmallOutline,
  statusUnassignedSmallFilled: statusUnassignedSmallFilled,
  statusUnassignedSmallOutline: statusUnassignedSmallOutline,
  subscribeFilledSmall: subscribeFilledSmall,
  subscribeSmall: subscribeSmall,
  subConvoSmall: subConvoSmall,
  subConvoFilledSmall: subConvoFilledSmall,
  switchFilledSmall: switchFilledSmall,
  tableColumnSmall: tableColumnSmall,
  tableGridFilledSmall: tableGridFilledSmall,
  tableGridSmall: tableGridSmall,
  tagFilledSmall: tagFilledSmall,
  tagIsNotFilledSmall: tagIsNotFilledSmall,
  tagsFilledSmall: tagsFilledSmall,
  tagSmall: tagSmall,
  tagsSmall: tagsSmall,
  targetOffSmall: targetOffSmall,
  taskFilledSmall: taskFilledSmall,
  taskSmall: taskSmall,
  teammateRoleFilledSmall: teammateRoleFilledSmall,
  teammateRoleSmall: teammateRoleSmall,
  teammatesFilledSmall: teammatesFilledSmall,
  teammatesSmall: teammatesSmall,
  templateSmall: templateSmall,
  textExpandSmall: textExpandSmall,
  thumbsdownSmall: thumbsdownSmall,
  thumbsupSmall: thumbsupSmall,
  ticketFilled: ticketFilled,
  ticketSmall: ticketSmall,
  timeFilledSmall: timeFilledSmall,
  timeSmall: timeSmall,
  togglesFilledSmall: togglesFilledSmall,
  togglesSmall: togglesSmall,
  topicFilledSmall: topicFilledSmall,
  topicSmall: topicSmall,
  translationSmall: translationSmall,
  trash01Small: trash01Small,
  trashFilledSmall: trashFilledSmall,
  trashSmall: trashSmall,
  twitterSmall: twitterSmall,
  unassignedFilledSmall: unassignedFilledSmall,
  unassignedSmall: unassignedSmall,
  unlinkedConversationsFilledSmall: unlinkedConversationsFilledSmall,
  unlinkedConversationsSmall: unlinkedConversationsSmall,
  unpinOutlineSmall: unpinOutlineSmall,
  userCircle02Small: userCircle02Small,
  variableSmall: variableSmall,
  verifiedFilledSmall: verifiedFilledSmall,
  videoSmall: videoSmall,
  visitorSourceUrlSmall: visitorSourceUrlSmall,
  voicemailSmall: voicemailSmall,
  warningFilledSmall: warningFilledSmall,
  whatsappSmall: whatsappSmall,
  workspaceFilledSmall: workspaceFilledSmall,
  workspaceSmall: workspaceSmall,
  analytics: analytics,
  archive: archive,
  article: article,
  assign: assign,
  attachment: attachment,
  auditTrail: auditTrail,
  bell: bell,
  blocks: blocks,
  briefcaseFilled: briefcaseFilled,
  briefcaseOutline: briefcaseOutline,
  buildingFilled: buildingFilled,
  buildingFilledCompany: buildingFilledCompany,
  businessHoursFilled: businessHoursFilled,
  calendar: calendar,
  calendarFilled: calendarFilled,
  calendarInvite: calendarInvite,
  calendars: calendars,
  callOutlined: callOutlined,
  channelCallFilled: channelCallFilled,
  channelChat: channelChat,
  channelEmail: channelEmail,
  channels: channels,
  channelsFilled: channelsFilled,
  changeStatus: changeStatus,
  changeStatusFilled: changeStatusFilled,
  chat: chat,
  chatFilled: chatFilled,
  checkmark: checkmark,
  chevron: chevron,
  chevronRight: chevronRight,
  clock: clock,
  close: close,
  code: code,
  collapse: collapse,
  compose: compose,
  composeFilled: composeFilled,
  contacts: contacts,
  contactsCutout: contactsCutout,
  contactsFilled: contactsFilled,
  contactsOutline: contactsOutline,
  content: contentIcon,
  copy: copy,
  csatFilled: csatFilled,
  customerPortalFilled: customerPortalFilled,
  customViews: customViews,
  customViewsFilled: customViewsFilled,
  date: date,
  dateFilled: dateFilled,
  developers: developers,
  download: download,
  dotsGrid: dotsGrid,
  draft: draft,
  dropdownNew: dropdownNew,
  dropdownNewInbox: dropdownNewInbox,
  dropdownNewLink: dropdownNewLink,
  dropdownNewTag: dropdownNewTag,
  dropdownUnassign: dropdownUnassign,
  dynamicVariable: dynamicVariable,
  dynamicVariableFilled: dynamicVariableFilled,
  edit: edit,
  emoji: emoji,
  emojiActivity: emojiActivity,
  emojiFlags: emojiFlags,
  emojiFood: emojiFood,
  emojiNature: emojiNature,
  emojiObjects: emojiObjects,
  emojiPeople: emojiPeople,
  emojiSymbols: emojiSymbols,
  emojiTravel: emojiTravel,
  endCallOutlined: endCallOutlined,
  eye: eye,
  exit: exit,
  expand: expand,
  export: exportIcon,
  externalLink: externalLink,
  feather: feather,
  filters: filters,
  folder: folder,
  folderOutline: folderOutline,
  folderLarge: folderLarge,
  formatting: formatting,
  formattingBlockquote: formattingBlockquote,
  formattingBold: formattingBold,
  formattingColor: formattingColor,
  formattingHighlight: formattingHighlight,
  formattingImage: formattingImage,
  formattingItalic: formattingItalic,
  formattingLink: formattingLink,
  formattingList: formattingList,
  formattingListSmall: formattingListSmall,
  formattingRemove: formattingRemove,
  formattingStrikethrough: formattingStrikethrough,
  formattingUnderline: formattingUnderline,
  forwardAudioFilled: forwardAudioFilled,
  gear: gear,
  gearFilled: gearFilled,
  goToConversation: goToConversation,
  gif: gif,
  graduationCapOutlined: graduationCapOutlined,
  group: group,
  guide: guide,
  help: help,
  helpFilled: helpFilled,
  helpIndicator: helpIndicator,
  history: history,
  hideP1: hideP1,
  hold: hold,
  holdFilled: holdFilled,
  homeFilled: homeFilled,
  horizontalRule: horizontalRule,
  imagesEmpty: imagesEmpty,
  inbox: inbox,
  inboxFilled: inboxFilled,
  inflowInbox: inflowInbox,
  info: info,
  infoFilled: infoFilled,
  integration: integration,
  integrationsFilled: integrationsFilled,
  keyboard: keyboard,
  keypad: keypad,
  keypadFilled: keypadFilled,
  knowledgeBase: knowledgeBase,
  knowledgeBaseOutlined: knowledgeBaseOutlined,
  knowledgeBaseFilled: knowledgeBaseFilled,
  lightbulb: lightbulb,
  lightning: lightning,
  lightningFilled: lightningFilled,
  like: like,
  likeFilled: likeFilled,
  link: link,
  linkedConversationsFilled: linkedConversationsFilled,
  list: list,
  listFilled: listFilled,
  lock: lock,
  lockFilled: lockFilled,
  mention: mention,
  menu: menu,
  merge: merge,
  message: message,
  messageTemplate: messageTemplate,
  messageTemplateFilled: messageTemplateFilled,
  messageTemplateLarge: messageTemplateLarge,
  more: more,
  moreSmall: moreSmall,
  moreVertical: moreVertical,
  moveActivityFilled: moveActivityFilled,
  moveRightFilled: moveRightFilled,
  mute: mute,
  muteFilled: muteFilled,
  new: newIcon,
  newContact: newContact,
  newEvent: newEvent,
  none: none,
  numbers: numbers,
  openPanel: openPanel,
  outbox: outbox,
  palmTree: palmTree,
  pauseFilled: pauseFilled,
  personFilled: personFilled,
  phone: phone,
  planet: planet,
  playFilled: playFilled,
  plusCircle: plusCircle,
  popin: popin,
  popout: popout,
  questionMark: questionMark,
  reminder: reminder,
  removeIntegration: removeIntegration,
  reopen: reopen,
  repeatCircle: repeatCircle,
  replayAudioFilled: replayAudioFilled,
  reply: reply,
  replyFilled: replyFilled,
  replyAll: replyAll,
  resnooze: resnooze,
  restore: restore,
  retweet: retweet,
  retweeted: retweeted,
  rocketFilled: rocketFilled,
  infoHistory: infoHistory,
  save: save,
  schedule: schedule,
  scheduleFilled: scheduleFilled,
  search: search,
  section: section,
  sectionFilled: sectionFilled,
  send: send,
  sendFilled: sendFilled,
  sequences: sequences,
  settings: settings,
  sidePane: sidePane,
  sla: sla,
  slaFilled: slaFilled,
  snooze: snooze,
  snoozeFilled: snoozeFilled,
  spam: spam,
  spamFilled: spamFilled,
  sparklesAi: sparklesAi,
  sparklesAiFilled: sparklesAiFilled,
  smartQAFilled: smartQAFilled,
  stageFilled: stageFilled,
  star: star,
  starFilled: starFilled,
  savedFlow: savedFlow,
  subscribed: subscribed,
  table: table,
  tableColumn: tableColumn,
  tableGrid: tableGrid,
  tableGridFilled: tableGridFilled,
  tag: tag,
  tagFilled: tagFilled,
  tags: tags,
  teammateFilled: teammateFilled,
  teammateRole: teammateRole,
  teammates: teammates,
  teammatesFilled: teammatesFilled,
  template: template,
  thumbsup: thumbsup,
  toggles: toggles,
  togglesFilled: togglesFilled,
  trash: trash,
  trashFilled: trashFilled,
  twitterFilled: twitterFilled,
  unassign: unassign,
  unassignedFilled: unassignedFilled,
  unlinkedConversationsFilled: unlinkedConversationsFilled,
  untag: untag,
  unlink: unlink,
  variable: variable,
  video: video,
  visitorSourceUrl: visitorSourceUrl,
  volumeAudioFilled: volumeAudioFilled,
  warningFilledTriangle: warningFilledTriangle,
  savedViewFilled: savedViewFilled,
  taskLarge: taskLarge,
  backspaceOutlined: backspaceOutlined,
  callFilled: callFilled,
  crossCircle: crossCircle,
  downloadCircle: downloadCircle,
  externalLinkCircle: externalLinkCircle,
  loaderRetry: loaderRetry,
  loaderRetrySmall: loaderRetrySmall,
  calendarSelected: calendarSelected,
  replyArrow: replyArrow,
  windowsMinimize: windowsMinimize,
  windowsMaximize: windowsMaximize,
  windowsUnmaximize: windowsUnmaximize,
  windowsClose: windowsClose,
  wfmFilledSmall: wfmFilledSmall,
  wfmSmall: wfmSmall,
});

export const legacyIcons = importedIcons;
export type LegacyIconName = keyof typeof importedIcons;
export type NewIconName = keyof typeof newIcons;

export type IconName = LegacyIconName | NewIconName;

function isLegacyIconName(s: any): s is LegacyIconName {
  return isString(s) && s in importedIcons;
}

export function isNewIconName(s: any): s is NewIconName {
  return isString(s) && s in newIcons;
}
export function isIconName(s: any): s is LegacyIconName {
  return isLegacyIconName(s) || isNewIconName(s);
}

export function isSmallIconName(name: IconName): boolean {
  return name.endsWith('Small') || name.endsWith('/16');
}

/*
 * Props.
 */

// TS Hack to allow auto-completion despite the fact that we allow any string as a color.
export type IconColorWithOverride = IconColor | (string & {});
export interface IconProps {
  color?: IconColorWithOverride;
  hoverColor?: IconColorWithOverride;
  isDisabled?: boolean;
  hasHover?: boolean;
  className?: string;
  isInline?: boolean;
  indicatorColor?: string;

  name: IconName;
  size?: number;

  /**
   * For debugging purposes.
   */
  forceUseLegacyIcons?: boolean;
}

/*
 * Component.
 */

interface IconStyleProps {
  $color?: string | IconColor;
  $hoverColor?: string | IconColor;
  $isDisabled?: boolean;
  $hasHover?: boolean;
}

const StyledIconSvg = styled.svg<IconStyleProps>`
  ${(p) => maybeAddColor(p)};
  &:not([aria-disabled='true']) {
    ${(p) => maybeAddHoverStyle(p)};
  }
  display: block;
  flex-shrink: 0;
`;

function maybeAddColor(props: IconStyleProps) {
  if (!props.$color) {
    return undefined;
  }

  if (isIconColor(props.$color)) {
    return css`
      color: ${resolveIconColor(props.$color)};
    `;
  }

  return css`
    color: ${props.$color};
  `;
}

function maybeAddHoverStyle(props: IconStyleProps) {
  if (!props.$hoverColor || props.$isDisabled) {
    return undefined;
  }

  const color = isIconColor(props.$hoverColor) ? resolveIconColor(props.$hoverColor) : props.$hoverColor;

  if (props.$hasHover) {
    return css`
      color: ${color};
    `;
  }

  return css`
    div:hover > && {
      color: ${color};
    }
  `;
}

function mapIconNameToContentId(name: IconName): string {
  return `icon-${name}`;
}

interface IconDetails extends SvgAsset {
  contentId: string;
  dataTestId: string;
}

function computeIconDetails(props: IconProps): IconDetails {
  const iconName =
    isLegacyIconName(props.name) && !props.forceUseLegacyIcons ? legacyIconMap[props.name] : props.name;
  const asset = isLegacyIconName(iconName) ? legacyIcons[iconName] : newIcons[iconName];

  if (!asset) {
    throw new Error(
      `[Icon] Unknown icon name: "${props.name}". ` +
        `Icons use "name/style/size" format (e.g., "inbox-01/outlined/16", "star-01/filled/16"). ` +
        `Check libs/shared/assets/src/icons/index.ts for available icons.`,
    );
  }

  return {
    ...asset,
    contentId: mapIconNameToContentId(iconName),
    dataTestId: iconName,
  };
}

const indicatorRadiusPx = 3;
const indicatorMaskElementId = 'icon-indicator-mask';
const indicatorCircleCenterX = 80;
const indicatorCircleCenterY = 20;

function computSvgContentWithIndicator(
  contentId: string,
  content: SvgAsset['content'] | React.ReactNode,
  indicatorColor: string,
) {
  return (
    <>
      <g mask={`url(#${contentId}-${indicatorMaskElementId})`}>{content}</g>
      <mask id={`${contentId}-${indicatorMaskElementId}`}>
        <rect width="100%" height="100%" fill="white" />
        <circle
          cx={`${indicatorCircleCenterX}%`}
          cy={`${indicatorCircleCenterY}%`}
          r={indicatorRadiusPx + 1}
          fill="black"
        />
      </mask>
      <circle
        cx={`${indicatorCircleCenterX}%`}
        cy={`${indicatorCircleCenterY}%`}
        r={indicatorRadiusPx}
        fill={indicatorColor}
      />
    </>
  );
}

function computeInlineSvgContent(
  contentId: string,
  content: SvgAsset['content'],
  indicatorColor: IconProps['indicatorColor'],
): Pick<HTMLProps<SVGElement>, 'dangerouslySetInnerHTML'> | Pick<HTMLProps<SVGElement>, 'children'> {
  if (indicatorColor) {
    return {
      children: computSvgContentWithIndicator(contentId, content, indicatorColor),
    };
  }

  return {
    dangerouslySetInnerHTML: buildCleanReactInnerHtml(content),
  };
}

/**
 * Renders one of the design system's named icons by its `name` (e.g. "search/outlined/16"). Use this component
 * for all icons instead of raw SVG or `img` tags, so sizing, coloring, hover states, and indicators stay
 * consistent. Control appearance with the `color`, `hoverColor`, `size`, and `indicatorColor` props.
 *
 * @summary for rendering design system icons by name
 */
export const Icon = memo<IconProps>((props) => {
  const {size, className, isInline, indicatorColor} = props;
  const {content, attributes, contentId, dataTestId} = computeIconDetails(props);

  const hasSvgContent = useSvgContent(contentId, () => content);

  const {viewBox, stroke, width, height} = buildIconAttributes(attributes, size);

  if (hasSvgContent && !isInline) {
    return (
      <StyledIconSvg
        $color={props.color}
        $hoverColor={props.hoverColor}
        aria-disabled={props.isDisabled}
        $hasHover={props.hasHover}
        className={className}
        width={width}
        height={height}
        fill="currentColor"
        stroke={stroke}
        viewBox={viewBox}
        data-testid={dataTestId}
        data-indicator={indicatorColor ? true : undefined}
      >
        {indicatorColor ? (
          computSvgContentWithIndicator(contentId, <use href={`#${contentId}`} />, indicatorColor)
        ) : (
          <use href={`#${contentId}`} />
        )}
      </StyledIconSvg>
    );
  }

  return (
    <StyledIconSvg
      $color={props.color}
      $hoverColor={props.hoverColor}
      aria-disabled={props.isDisabled}
      $hasHover={props.hasHover}
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      stroke={stroke}
      viewBox={viewBox}
      data-testid={dataTestId}
      data-indicator={indicatorColor ? true : undefined}
      {...computeInlineSvgContent(contentId, content, indicatorColor)}
    />
  );
});
